import React from "react";
import Question from "./Question";

function FAQ() {

  return (
    <div className="bg-yellow-100">
      <div className="py-16 mx-auto w-5/6 max-w-4xl">
        <h3 className="mb-12 text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">Frequently Asked Questions</h3>
        <hr className="border-b border-gray-100" />
        <Question 
          question="This is a question?"
          answer="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <Question 
          question="This is another question?"
          answer="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <Question 
          question="More questions?!"
          answer="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />                                         
      </div>
    </div>
  )
}

export default FAQ;